// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__w071e","inner":"Footer_inner__8UDOl"};